import OverviewTopic from './OverviewTopic';
import FAQTopic from './FAQTopic';
import HowToVideoTopic from './HowToVideoTopic';

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import SmartDisplayOutlinedIcon from '@mui/icons-material/SmartDisplayOutlined';

export default [
  {id: 0, title: 'Overview', icon: <HomeOutlinedIcon/>, component: <OverviewTopic/>},
  {id: 1, title: 'FAQ', icon: <LiveHelpOutlinedIcon/>, component: <FAQTopic/>},
  {id: 2, title: 'Video: How to get set up', icon: <SmartDisplayOutlinedIcon/>, component: <HowToVideoTopic/>}
];